import React from 'react';

import { UrlLink, WP_HouseMainPage } from '../../model/models';
import { SanitizeHTML } from '../globals/SanitizeHTML';
import { ModelsService } from '../../services/ModelsService';
import { useCurrentHouse } from '../../hooks/HouseHooks';

interface HouseCardProps {
  houseMainPage: WP_HouseMainPage;
}

const HouseCard: React.FC<HouseCardProps> = ({ houseMainPage }) => {
  const address = houseMainPage.acf.address;
  const adresse_split = address.split(/\n/g);

  const house = useCurrentHouse();

  const houseName = ModelsService.getHouseNameFromTerm(
    house,
    houseMainPage.title.rendered
  );

  return (
    <div className="house-card relative bg-secondary overflow-hidden shadow rounded-3xl px-2 mt-4 min-h-cardhouse md:px-5 md:py-4">
      <svg
        className="absolute left-0 top-0 h-full"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 52.6 77.6"
      >
        <g>
          <path
            d="M43.5,68.3c-4.5,4.6-10.6,7.1-17.1,7.1c-6.5,0-12.6-2.5-17.1-7.1C5,63.9,2.5,58,2.5,52.1V25.6
            c0-5.9,2.5-11.8,6.8-16.2c4.5-4.6,10.6-7.1,17.1-7.1c6.5,0,12.6,2.5,17.1,7.1c4.3,4.4,6.8,10.3,6.8,16.2c0,6.1-4.6,9.5-8.8,9.5
            c-4.9,0-9-4.1-9-8.9c0-3.8-3.1-6.1-5.9-6.1c-3.5,0-6.3,2.7-6.3,6.1v25.5c0,3.4,2.8,6.1,6.3,6.1c2.8,0,5.9-2.3,5.9-6.1
            c0-4.8,4.1-8.9,9-8.9c4.3,0,8.8,3.3,8.8,9.5C50.3,58,47.8,63.9,43.5,68.3 M41.5,40.4c-6.1,0-11.3,5.1-11.3,11.1
            c0,2.3-1.9,3.9-3.7,3.9c-2,0-4-1.4-4-3.8V26.1c0-2.4,2.1-3.8,4-3.8c1.8,0,3.7,1.6,3.7,3.9c0,6,5.2,11.1,11.3,11.1
            c6.9,0,11.1-6,11.1-11.7c0-6.5-2.7-12.9-7.4-17.7c-5-5-11.6-7.8-18.7-7.8C19.3,0,12.6,2.8,7.7,7.8C3,12.6,0.3,19.1,0.3,25.6v26.5
            C0.3,58.6,3,65,7.7,69.8c5,5,11.6,7.8,18.7,7.8c7.1,0,13.8-2.8,18.7-7.8c4.7-4.8,7.4-11.3,7.4-17.7C52.6,46.3,48.4,40.4,41.5,40.4"
            fill="black"
            fillOpacity="0.05"
          />
          <path
            d="M41.3,50.4c-0.6,0-1.1,0.5-1.1,1.1c0,7.6-6.2,13.9-13.8,13.9c-6.7,0-13.9-5.4-13.9-13.5v-26
            c0-8.1,7.2-13.6,13.9-13.6c7.6,0,13.8,6.2,13.8,13.9c0,0.6,0.5,1.1,1.1,1.1c0.6,0,1.1-0.5,1.1-1.1c0-8.9-7.2-16.1-16.1-16.1
            c-4.4,0-8.5,1.7-11.6,4.9c-2.9,3-4.6,7-4.6,10.9v26c0,4,1.7,8,4.6,10.9c3.1,3.1,7.2,4.9,11.6,4.9c8.9,0,16.1-7.2,16.1-16.1
            C42.5,50.9,41.9,50.4,41.3,50.4"
            fill="black"
            fillOpacity="0.05"
          />
          <path
            d="M26.2,70.3c-10.3,0-18.7-8.4-18.7-18.8v-0.1V26.1v-0.1c0-10.4,8.4-18.8,18.7-18.8c10.3,0,19.1,8.6,19.1,18.8
            c0,1.9-1.3,3.9-3.9,3.9c-2.4,0-4-1.6-4-3.9c0-6.5-4.5-11.1-11-11.1c-6.4,0-11.1,4.7-11.1,11.1v0.1v25.3v0.1c0,6.5,4.6,11,11.1,11
            c6.5,0,11-4.5,11-11c0-2.4,1.6-3.9,4-3.9c2.6,0,3.9,2,3.9,3.9C45.2,61.7,36.5,70.3,26.2,70.3 M41.3,45.4c-3.7,0-6.2,2.6-6.2,6.2
            c0,5.3-3.5,8.8-8.8,8.8c-5.2,0-8.9-3.6-8.9-8.8v-0.1V26.1v-0.1c0-5.2,3.6-8.8,8.9-8.8c5.3,0,8.8,3.5,8.8,8.8c0,3.6,2.6,6.1,6.2,6.2
            c4,0,6.2-3.2,6.2-6.2C47.5,14.7,37.7,5,26.2,5c-11.6,0-21,9.4-21,21.1v0.1v25.3v0.1c0,11.6,9.4,21,21,21c11.6,0,21.3-9.6,21.3-21
            C47.5,47.5,44.3,45.4,41.3,45.4"
            fill="black"
            fillOpacity="0.05"
          />
        </g>
      </svg>
      <div className="flex flex-col justify-between h-full px-4 py-5">
        <div className="flex w-full justify-between items-start">
          <div>
            <SanitizeHTML
              html={houseName}
              tag="h4"
              className="text-lg font-bold leading-6 text-white md:text-2xl"
            />
            <div className="mt-2">
              {adresse_split.map((address, index) => {
                return (
                  <SanitizeHTML
                    key={index}
                    html={address}
                    className="mb-1 leading-3 text-xs text-white"
                  />
                );
              })}
            </div>
          </div>
          <div className="ml-4 flex-shrink-0">
            <div className="image-wrapper rounded-full flex justify-center items-center border-white border-opacity-20 border h-20 w-20 md:w-32 md:h-32">
              {house && (
                <img
                  className="inline-block h-16 w-16 rounded-full md:h-28 md:w-28"
                  src={house.acf?.image?.sizes?.thumbnail}
                  alt=""
                />
              )}
            </div>
          </div>
        </div>
        <ul className="flex w-full items-start mt-2">
          {houseMainPage.acf.links &&
            houseMainPage.acf.links.map((link: UrlLink, index) => {
              return link.url ? (
                <li className="mr-6 z-10" key={index}>
                  <a
                    href={link.url}
                    target="_blank"
                    rel="noreferrer"
                    className="text-white"
                  >
                    <i className={link.icon.class} aria-hidden="true"></i>
                  </a>
                </li>
              ) : (
                ''
              );
            })}
        </ul>
      </div>
    </div>
  );
};

export default HouseCard;
